import React from 'react'
import { SettingsMenuItem, SettingsMenuItemProps } from './settings-menu-item'
import {
  SettingsMenuButton,
  SettingsMenuButtonProps,
} from 'src/editor/shared/components/settings-menu-buttons/settings-menu-button'
import { twMerge } from 'tailwind-merge'

export interface SettingsMenuButtonWithIconProps
  extends SettingsMenuButtonProps,
    Pick<SettingsMenuItemProps, 'title' | 'subtitle'> {
  iconBefore: () => React.ReactNode
  endElement?: () => React.ReactNode
}

export const SettingsMenuButtonWithIcon = ({
  className,
  title,
  subtitle,
  iconBefore,
  onClick,
  endElement,
  icon,
  ...props
}: SettingsMenuButtonWithIconProps) => {
  return (
    <SettingsMenuButton
      className={twMerge('px-0 py-0', className)}
      onClick={onClick}
      icon={icon ?? (() => null)}
      {...props}
    >
      <SettingsMenuItem title={title} subtitle={subtitle} icon={iconBefore} />
      {endElement?.()}
    </SettingsMenuButton>
  )
}
